import React, { Suspense } from 'react'
import type { KambiSportName } from '@mobi/api-types/kambi/sports'
import { DefaultIcon, type DefaultIconType } from './Components/Common/DefaultIcon'
import { mappedSportsWithNationalFlags } from './Components/index'

export const TeamIcon: React.FC<{
  size: string
  participantId: number | null | undefined
  sportName: KambiSportName | undefined
  defaultIconType?: DefaultIconType
}> = ({ participantId, size, sportName, defaultIconType }) => {
  const MappedIcon = participantId && sportName && mappedSportsWithNationalFlags[sportName]

  if (MappedIcon) {
    return (
      <Suspense fallback={null}>
        <MappedIcon
          size={size}
          participantId={participantId}
          sportName={sportName}
          defaultIconType={defaultIconType ?? null}
        />
      </Suspense>
    )
  }

  return (
    <DefaultIcon
      sportName={sportName}
      defaultIconType={defaultIconType ?? (sportName ? 'sport-icon' : null)}
      size={size}
      showDefaultShield={false}
    />
  )
}
